import { SearchX } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"

/**
 * OKS-31 — "No missions match these filters" panel.
 *
 * Renders inside the table slot when the brand has missions overall
 * (`is_empty === false`) but the active filter set returns zero rows.
 * Distinct from the OKS-29 brand-empty `EmptyState` (whose CTA is
 * "Create your first mission") — this panel's CTA is "Clear filters"
 * to recover from a too-narrow filter combo without losing the page
 * chrome.
 */
interface MissionListNoResultsProps {
  onClearFilters: () => void
}

export function MissionListNoResults({
  onClearFilters,
}: MissionListNoResultsProps) {
  const { t } = useTranslation()

  return (
    <div
      className="border-input flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed p-12 text-center"
      data-testid="mission-list-no-results"
    >
      <SearchX className="text-muted-foreground size-8" aria-hidden="true" />
      <h2 className="text-foreground text-lg font-medium">
        {t("missions.index.no_results.title")}
      </h2>
      <p className="text-muted-foreground max-w-md text-sm">
        {t("missions.index.no_results.body")}
      </p>
      <Button
        type="button"
        variant="outline"
        onClick={onClearFilters}
        data-testid="mission-list-no-results-clear"
      >
        {t("missions.index.no_results.clear_cta")}
      </Button>
    </div>
  )
}
